import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Accreditations } from './components/Accreditations';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { QuoteCard } from './components/QuoteCard';
import { WhyChooseUs } from './components/WhyChooseUs';
import { StormDamage } from './components/StormDamage';
import { Financing } from './components/Financing';
import { Reviews } from './components/Reviews';
import { ServiceArea } from './components/ServiceArea';
import { CTABand } from './components/CTABand';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
import { QuotePopup } from './components/QuotePopup';
export function App() {
  return <div className="w-full min-h-screen bg-white overflow-x-hidden font-sans text-tx-body selection:bg-tx-red selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Accreditations data-id="element-4" />
        <TrustBar data-id="element-5" />
        <Services data-id="element-6" />
        <section className="py-12 bg-white" data-id="element-7">
          <div className="container mx-auto px-4" data-id="element-8">
            <QuoteCard className="max-w-3xl mx-auto" data-id="element-9" />
          </div>
        </section>
        <WhyChooseUs data-id="element-10" />
        <StormDamage data-id="element-11" />
        <Financing data-id="element-12" />
        <Reviews data-id="element-13" />
        <ServiceArea data-id="element-14" />
        <CTABand data-id="element-15" />
        <ContactForm data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
      <QuotePopup data-id="element-18" />
    </div>;
}